const p = (english, mandarin, spoken) => ({ english, mandarin, spoken });
const group = (id, title, phrases) => ({ id, title, phrases });

export const tensePhraseSets = [
  {
    id: 'past',
    title: 'Talking About the Past',
    groups: [
      group('past-patterns', 'Universal Patterns', [
        p('I + past verb', 'wǒ + dòngcí + le', '我吃了'),
        p('I have + past participle', 'wǒ + dòngcí + guo', '我吃过'),
        p('I was + verb-ing', 'wǒ zhèngzài + dòngcí', '我正在吃'),
        p('I used to + verb', 'wǒ yǐqián + dòngcí', '我以前住在那里'),
        p('I had + noun', 'wǒ yǒu + míngcí', '我有一个问题'),
        p('I went to + place', 'wǒ qù le + dìfang', '我去了商店'),
        p('I saw / heard / felt + noun', 'wǒ kànjiàn / tīngjiàn / gǎndào…', '我看见了'),
        p('I couldn’t + verb', 'wǒ méi fázi + dòngcí', '我没办法'),
        p('I didn’t + verb', 'wǒ méi yǒu + dòngcí', '我没有'),
        p('I remember + noun/verb-ing', 'wǒ jìde…', '我记得'),
      ]),
      group('past-phrases', 'Past-Focused Phrases', [
        p('I ate at that restaurant yesterday.', 'wǒ zuótiān zài nà jiā cāntīng chī le fàn', '我昨天在那家餐厅吃了饭'),
        p('I wrote something important today.', 'wǒ jīntiān xiě le yì xiē zhòngyào de dōngxi', '我今天写了一些重要的东西'),
        p('I walked to the store earlier.', 'wǒ gāngcái zǒu lù qù le shāngdiàn', '我刚才走路去了商店'),
        p('I worked all day.', 'wǒ gōngzuò le yì zhěng tiān', '我工作了一整天'),
        p('I slept very late last night.', 'wǒ zuótiān wǎnshang shuì de hěn wǎn', '我昨天晚上睡得很晚'),
        p('I cooked dinner yesterday.', 'wǒ zuótiān zuò le wǎnfàn', '我昨天做了晚饭'),
        p('I cleaned the room this morning.', 'wǒ jīntiān zǎoshang dǎsǎo le fángjiān', '我今天早上打扫了房间'),
        p('I bought something new.', 'wǒ mǎi le xīn dōngxi', '我买了新东西'),
        p('I paid for everything already.', 'wǒ yǐjīng fù le suǒyǒu de qián', '我已经付了所有的钱'),
        p('I helped my friend last week.', 'wǒ shàng zhōu bāng le wǒ péngyou', '我上周帮了我朋友'),
        p('I saw that movie before.', 'wǒ yǐqián kàn guo nà bù diànyǐng', '我以前看过那部电影'),
        p('I heard that story already.', 'wǒ yǐjīng tīng guo nà ge gùshi', '我已经听过那个故事'),
        p('I felt tired yesterday.', 'wǒ zuótiān gǎndào hěn lèi', '我昨天感到很累'),
        p('I knew the answer before.', 'wǒ yǐqián jiù zhīdào dá’àn', '我以前就知道答案'),
        p('I thought about that yesterday.', 'wǒ zuótiān xiǎng guo nà jiàn shì', '我昨天想过那件事'),
        p('I found the keys earlier.', 'wǒ gāngcái zhǎodào le yàoshi', '我刚才找到了钥匙'),
        p('I made a mistake last time.', 'wǒ shàng cì fàn le yí ge cuòwù', '我上次犯了一个错误'),
        p('I took the bus yesterday.', 'wǒ zuótiān zuò le gōngjiāo chē', '我昨天坐了公交车'),
        p('I came home late.', 'wǒ huí jiā hěn wǎn', '我回家很晚'),
        p('I went to the market.', 'wǒ qù le shìchǎng', '我去了市场'),
        p('I used to live there.', 'wǒ yǐqián zhù zài nàlǐ', '我以前住在那里'),
        p('I used to work in that place.', 'wǒ yǐqián zài nà ge dìfang gōngzuò', '我以前在那个地方工作'),
        p('I used to eat here often.', 'wǒ yǐqián chángcháng zài zhèlǐ chīfàn', '我以前常常在这里吃饭'),
        p('I was working when you called.', 'nǐ dǎ diànhuà de shíhou wǒ zhèngzài gōngzuò', '你打电话的时候我正在工作'),
        p('I was cooking when they arrived.', 'tāmen dàodá de shíhou wǒ zhèngzài zuòfàn', '他们到达的时候我正在做饭'),
        p('I was sleeping at that time.', 'nà ge shíhou wǒ zhèngzài shuìjiào', '那个时候我正在睡觉'),
        p('I was waiting for you.', 'wǒ zhèngzài děng nǐ', '我正在等你'),
        p('I had a problem yesterday.', 'wǒ zuótiān yǒu yí ge wèntí', '我昨天有一个问题'),
        p('I had a meeting earlier.', 'wǒ gāngcái yǒu yí ge huìyì', '我刚才有一个会议'),
        p('I had no time last week.', 'wǒ shàng zhōu méi yǒu shíjiān', '我上周没有时间'),
        p('I didn’t understand yesterday.', 'wǒ zuótiān méi dǒng', '我昨天没懂'),
        p('I didn’t hear you.', 'wǒ méi tīngjiàn nǐ', '我没听见你'),
        p('I didn’t see anything.', 'wǒ shénme dōu méi kànjiàn', '我什么都没看见'),
        p('I didn’t know that.', 'wǒ bù zhīdào nà jiàn shì', '我不知道那件事'),
        p('I couldn’t find the place.', 'wǒ zhǎo bú dào nà ge dìfang', '我找不到那个地方'),
        p('I couldn’t finish the task.', 'wǒ wánchéng bù liǎo nà ge rènwù', '我完成不了那个任务'),
        p('I couldn’t come yesterday.', 'wǒ zuótiān lái bù liǎo', '我昨天来不了'),
        p('I remember meeting you.', 'wǒ jìde jiàn guo nǐ', '我记得见过你'),
        p('I remember that moment.', 'wǒ jìde nà ge shùnjiān', '我记得那个瞬间'),
        p('I remember the conversation.', 'wǒ jìde nà cì tánhuà', '我记得那次谈话'),
        p('I have eaten here before.', 'wǒ yǐqián zài zhèlǐ chī guo', '我以前在这里吃过'),
        p('I have written about that.', 'wǒ xiě guo nà jiàn shì', '我写过那件事'),
        p('I have seen this many times.', 'wǒ kàn guo zhè ge hěn duō cì', '我看过这个很多次'),
        p('I have tried that already.', 'wǒ yǐjīng shì guo le', '我已经试过了'),
        p('I have learned a lot.', 'wǒ xué dào le hěn duō', '我学到了很多'),
        p('I have visited that place.', 'wǒ qù guo nà ge dìfang', '我去过那个地方'),
        p('I have met them before.', 'wǒ yǐqián jiàn guo tāmen', '我以前见过他们'),
        p('I have worked in that field.', 'wǒ zài nà ge lǐngyù gōngzuò guo', '我在那个领域工作过'),
        p('I have heard this song.', 'wǒ tīng guo zhè shǒu gē', '我听过这首歌'),
        p('I have felt this way before.', 'wǒ yǐqián yǒu guo zhè zhǒng gǎnjué', '我以前有过这种感觉'),
      ]),
    ],
  },
  {
    id: 'future',
    title: 'Talking About the Future',
    groups: [
      group('future-patterns', 'Universal Patterns', [
        p('I will + verb', 'wǒ huì + dòngcí', '我会去'),
        p('I’m going to + verb', 'wǒ yào + dòngcí', '我要去旅行'),
        p('I plan to + verb', 'wǒ dǎsuàn + dòngcí', '我打算'),
        p('I want to + verb', 'wǒ xiǎng + dòngcí', '我想'),
        p('I hope to + verb', 'wǒ xīwàng + dòngcí', '我希望'),
        p('I expect to + verb', 'wǒ yùjì + dòngcí', '我预计'),
        p('I might + verb', 'wǒ kěnéng huì + dòngcí', '我可能会'),
        p('I will be + verb-ing', 'wǒ huì zhèngzài + dòngcí', '我会在工作'),
        p('I’m about to + verb', 'wǒ jiùyào + dòngcí', '我就要'),
        p('I’m thinking about + verb-ing', 'wǒ zài kǎolǜ + dòngcí', '我在考虑'),
      ]),
      group('future-phrases', 'Future-Focused Phrases', [
        p('I will go tomorrow.', 'wǒ míngtiān huì qù', '我明天会去'),
        p('I will eat later.', 'wǒ yìhuǐr huì chī', '我一会儿会吃'),
        p('I will call you soon.', 'wǒ hěn kuài huì gěi nǐ dǎ diànhuà', '我很快会给你打电话'),
        p('I will finish this today.', 'wǒ jīntiān huì wánchéng zhè ge', '我今天会完成这个'),
        p('I will help you tomorrow.', 'wǒ míngtiān huì bāng nǐ', '我明天会帮你'),
        p('I will meet them next week.', 'wǒ xià zhōu huì jiàn tāmen', '我下周会见他们'),
        p('I will try again.', 'wǒ huì zài shì yí cì', '我会再试一次'),
        p('I will learn more.', 'wǒ huì xué gèng duō', '我会学更多'),
        p('I will buy something later.', 'wǒ yìhuǐr huì mǎi diǎn dōngxi', '我一会儿会买点东西'),
        p('I will check the details.', 'wǒ huì chá yíxià xiángqíng', '我会查一下详情'),
        p('I’m going to travel soon.', 'wǒ hěn kuài yào qù lǚxíng', '我很快要去旅行'),
        p('I’m going to cook tonight.', 'wǒ jīntiān wǎnshang yào zuòfàn', '我今天晚上要做饭'),
        p('I’m going to clean the room.', 'wǒ yào dǎsǎo fángjiān', '我要打扫房间'),
        p('I’m going to study later.', 'wǒ yìhuǐr yào xuéxí', '我一会儿要学习'),
        p('I’m going to rest today.', 'wǒ jīntiān yào xiūxi', '我今天要休息'),
        p('I plan to visit that place.', 'wǒ dǎsuàn qù nà ge dìfang', '我打算去那个地方'),
        p('I plan to work more.', 'wǒ dǎsuàn duō gōngzuò yìdiǎn', '我打算多工作一点'),
        p('I plan to move next year.', 'wǒ dǎsuàn míngnián bānjiā', '我打算明年搬家'),
        p('I plan to learn the language.', 'wǒ dǎsuàn xué zhè mén yǔyán', '我打算学这门语言'),
        p('I plan to meet new people.', 'wǒ dǎsuàn rènshi xīn péngyou', '我打算认识新朋友'),
        p('I want to go out tonight.', 'wǒ jīntiān wǎnshang xiǎng chūqù', '我今天晚上想出去'),
        p('I want to eat something good.', 'wǒ xiǎng chī diǎn hǎochī de', '我想吃点好吃的'),
        p('I want to talk to you later.', 'wǒ yìhuǐr xiǎng hé nǐ tán', '我一会儿想和你谈'),
        p('I want to finish this soon.', 'wǒ xiǎng hěn kuài wánchéng zhè ge', '我想很快完成这个'),
        p('I want to improve my skills.', 'wǒ xiǎng tígāo wǒ de jìnéng', '我想提高我的技能'),
        p('I hope to see you tomorrow.', 'wǒ xīwàng míngtiān jiàn dào nǐ', '我希望明天见到你'),
        p('I hope to learn quickly.', 'wǒ xīwàng néng kuài diǎn xuéhuì', '我希望能快点学会'),
        p('I hope to travel this year.', 'wǒ xīwàng jīnnián qù lǚxíng', '我希望今年去旅行'),
        p('I hope to meet them soon.', 'wǒ xīwàng hěn kuài jiàn dào tāmen', '我希望很快见到他们'),
        p('I hope to get better.', 'wǒ xīwàng néng biàn hǎo', '我希望能变好'),
        p('I expect to finish today.', 'wǒ yùjì jīntiān néng wánchéng', '我预计今天能完成'),
        p('I expect to arrive early.', 'wǒ yùjì huì zǎo dào', '我预计会早到'),
        p('I expect to hear from you.', 'wǒ qídài nǐ de huífù', '我期待你的回复'),
        p('I expect to understand more.', 'wǒ yùjì huì dǒng gèng duō', '我预计会懂更多'),
        p('I expect to improve.', 'wǒ yùjì huì yǒu jìnbù', '我预计会有进步'),
        p('I might go later.', 'wǒ kěnéng yìhuǐr qù', '我可能一会儿去'),
        p('I might eat something.', 'wǒ kěnéng huì chī diǎn dōngxi', '我可能会吃点东西'),
        p('I might call you tonight.', 'wǒ kěnéng jīntiān wǎnshang gěi nǐ dǎ diànhuà', '我可能今天晚上给你打电话'),
        p('I might stay home.', 'wǒ kěnéng dāi zài jiā', '我可能待在家'),
        p('I might change my plan.', 'wǒ kěnéng huì gǎi jìhuà', '我可能会改计划'),
        p('I will be working tomorrow.', 'wǒ míngtiān huì zài gōngzuò', '我明天会在工作'),
        p('I will be traveling next week.', 'wǒ xià zhōu huì zài lǚxíng', '我下周会在旅行'),
        p('I will be waiting for you.', 'wǒ huì zài děng nǐ', '我会在等你'),
        p('I will be studying tonight.', 'wǒ jīntiān wǎnshang huì zài xuéxí', '我今天晚上会在学习'),
        p('I will be cooking later.', 'wǒ yìhuǐr huì zài zuòfàn', '我一会儿会在做饭'),
        p('I’m about to leave.', 'wǒ jiùyào zǒu le', '我就要走了'),
        p('I’m about to start.', 'wǒ jiùyào kāishǐ le', '我就要开始了'),
        p('I’m about to call them.', 'wǒ jiùyào gěi tāmen dǎ diànhuà le', '我就要给他们打电话了'),
        p('I’m thinking about going out.', 'wǒ zài kǎolǜ chūqù', '我在考虑出去'),
        p('I’m thinking about learning more.', 'wǒ zài kǎolǜ duō xué yìdiǎn', '我在考虑多学一点'),
      ]),
    ],
  },
  {
    id: 'wishes-conditions',
    title: 'Wishes & Conditions',
    groups: [
      group('wish-patterns', 'Universal Patterns', [
        p('If + present, future', 'rúguǒ…, jiù…', '如果你来，我们就聚会'),
        p('If + past, would + verb', 'rúguǒ… de huà, wǒ huì…', '如果你来，我会帮忙'),
        p('I wish + past', 'wǒ xīwàng…', '我希望你来'),
        p('I wish + could/would', 'wǒ xīwàng néng / yuàn yì…', '我希望能'),
        p('I hope + present/future', 'wǒ xīwàng…', '我希望'),
        p('I would + verb', 'wǒ huì…', '我会'),
        p('I would like to + verb', 'wǒ xiǎng…', '我想'),
        p('If only + past', 'yàoshi… jiù hǎo le', '要是就好了'),
        p('I wish I had + noun/verb', 'wǒ xīwàng wǒ yǒu…', '我希望我有'),
        p('I wish things were different', 'wǒ xīwàng shìqing bú yíyàng', '我希望事情不一样'),
      ]),
      group('wish-phrases', 'Wishes & Conditions Phrases', [
        p('If you come tomorrow, we will party.', 'rúguǒ nǐ míngtiān lái, wǒmen jiù jùhuì', '如果你明天来，我们就聚会'),
        p('If you call me, I will answer.', 'rúguǒ nǐ gěi wǒ dǎ diànhuà, wǒ jiù jiē', '如果你给我打电话，我就接'),
        p('If you need help, I will help you.', 'rúguǒ nǐ xūyào bāngzhù, wǒ jiù bāng nǐ', '如果你需要帮助，我就帮你'),
        p('If it rains, we will stay home.', 'rúguǒ xiàyǔ, wǒmen jiù dāi zài jiā', '如果下雨，我们就待在家'),
        p('If I finish early, I will go out.', 'rúguǒ wǒ zǎo diǎn wánchéng, wǒ jiù chūqù', '如果我早点完成，我就出去'),
        p('If you arrive late, tell me.', 'rúguǒ nǐ dào de wǎn, gàosu wǒ', '如果你到得晚，告诉我'),
        p('If you want, we can talk.', 'rúguǒ nǐ yuànyì, wǒmen kěyǐ tán', '如果你愿意，我们可以谈'),
        p('If you try, you will improve.', 'rúguǒ nǐ nǔlì, nǐ jiù huì jìnbù', '如果你努力，你就会进步'),
        p('If you study, you will learn.', 'rúguǒ nǐ xuéxí, nǐ jiù huì xuéhuì', '如果你学习，你就会学会'),
        p('If you eat now, you will feel better.', 'rúguǒ nǐ xiànzài chī diǎn, nǐ huì gǎndào hǎo yìdiǎn', '如果你现在吃点，你会感到好一点'),
        p('If you came tomorrow, we would party.', 'rúguǒ nǐ míngtiān néng lái, wǒmen jiù huì jùhuì', '如果你明天能来，我们就会聚会'),
        p('If you lived here, we would meet often.', 'rúguǒ nǐ zhù zài zhèlǐ, wǒmen jiù huì cháng cháng jiànmiàn', '如果你住在这里，我们就会常常见面'),
        p('If I had time, I would help.', 'rúguǒ wǒ yǒu shíjiān, wǒ jiù huì bāngmáng', '如果我有时间，我就会帮忙'),
        p('If I knew the answer, I would tell you.', 'rúguǒ wǒ zhīdào dá’àn, wǒ jiù huì gàosu nǐ', '如果我知道答案，我就会告诉你'),
        p('If I were there, I would support you.', 'rúguǒ wǒ zài nàlǐ, wǒ jiù huì zhīchí nǐ', '如果我在那里，我就会支持你'),
        p('If I could go, I would go.', 'rúguǒ wǒ néng qù, wǒ jiù huì qù', '如果我能去，我就会去'),
        p('If I could choose, I would choose this.', 'rúguǒ wǒ néng xuǎnzé, wǒ jiù huì xuǎn zhè ge', '如果我能选择，我就会选这个'),
        p('If I had money, I would travel.', 'rúguǒ wǒ yǒu qián, wǒ jiù huì qù lǚxíng', '如果我有钱，我就会去旅行'),
        p('If I had more time, I would learn more.', 'rúguǒ wǒ yǒu gèng duō shíjiān, wǒ jiù huì duō xué', '如果我有更多时间，我就会多学'),
        p('If I had the chance, I would try.', 'rúguǒ wǒ yǒu jīhuì, wǒ jiù huì shìshi', '如果我有机会，我就会试试'),
        p('I wish you would come to my party.', 'wǒ xīwàng nǐ néng lái wǒ de jùhuì', '我希望你能来我的聚会'),
        p('I wish you were here.', 'wǒ xīwàng nǐ zài zhèlǐ', '我希望你在这里'),
        p('I wish I could go.', 'wǒ xīwàng wǒ néng qù', '我希望我能去'),
        p('I wish I could speak better.', 'wǒ xīwàng wǒ néng shuō de gèng hǎo', '我希望我能说得更好'),
        p('I wish I had more time.', 'wǒ xīwàng wǒ yǒu gèng duō shíjiān', '我希望我有更多时间'),
        p('I wish I had learned earlier.', 'wǒ xīwàng wǒ zǎo diǎn xué', '我希望我早点学'),
        p('I wish things were easier.', 'wǒ xīwàng shìqing néng jiǎndān yìdiǎn', '我希望事情能简单一点'),
        p('I wish today were longer.', 'wǒ xīwàng jīntiān néng gèng cháng', '我希望今天能更长'),
        p('I wish I didn’t feel tired.', 'wǒ xīwàng wǒ bú huì gǎndào lèi', '我希望我不会感到累'),
        p('I wish I understood everything.', 'wǒ xīwàng wǒ néng dǒng yíqiè', '我希望我能懂一切'),
        p('I hope you come tomorrow.', 'wǒ xīwàng nǐ míngtiān lái', '我希望你明天来'),
        p('I hope you feel better.', 'wǒ xīwàng nǐ gǎndào hǎo yìdiǎn', '我希望你感到好一点'),
        p('I hope we meet soon.', 'wǒ xīwàng wǒmen hěn kuài jiànmiàn', '我希望我们很快见面'),
        p('I hope things improve.', 'wǒ xīwàng shìqing huì hǎo qǐlai', '我希望事情会好起来'),
        p('I hope you like it.', 'wǒ xīwàng nǐ xǐhuan', '我希望你喜欢'),
        p('I would help if I could.', 'rúguǒ wǒ néng, wǒ jiù huì bāngmáng', '如果我能，我就会帮忙'),
        p('I would go if I had time.', 'rúguǒ wǒ yǒu shíjiān, wǒ jiù huì qù', '如果我有时间，我就会去'),
        p('I would stay if you asked.', 'rúguǒ nǐ qǐngqiú, wǒ jiù huì liúxià', '如果你请求，我就会留下'),
        p('I would try if I knew how.', 'rúguǒ wǒ zhīdào zěnme zuò, wǒ jiù huì shì', '如果我知道怎么做，我就会试'),
        p('I would learn if I had a teacher.', 'rúguǒ wǒ yǒu lǎoshī, wǒ jiù huì xué', '如果我有老师，我就会学'),
        p('I would like to meet you.', 'wǒ xiǎng jiàn nǐ', '我想见你'),
        p('I would like to learn more.', 'wǒ xiǎng duō xué yìdiǎn', '我想多学一点'),
        p('I would like to visit that place.', 'wǒ xiǎng qù nà ge dìfang', '我想去那个地方'),
        p('I would like to talk later.', 'wǒ xiǎng yìhuǐr zài tán', '我想一会儿再谈'),
        p('I would like to try again.', 'wǒ xiǎng zài shì yí cì', '我想再试一次'),
        p('If only you were here.', 'yàoshi nǐ zài zhèlǐ jiù hǎo le', '要是你在这里就好了'),
        p('If only I had more time.', 'yàoshi wǒ yǒu gèng duō shíjiān jiù hǎo le', '要是我有更多时间就好了'),
        p('If only I knew the truth.', 'yàoshi wǒ zhīdào zhēnxiàng jiù hǎo le', '要是我知道真相就好了'),
        p('If only things were different.', 'yàoshi shìqing bú yíyàng jiù hǎo le', '要是事情不一样就好了'),
        p('If only I could speak perfectly.', 'yàoshi wǒ néng shuō de wánměi jiù hǎo le', '要是我能说得完美就好了'),
      ]),
    ],
  },
];
